<template>
  <div class="box">

    <div class="handle-box-search">

      <el-row type="flex" justify="center" style="margin-bottom: 20px;">

        <span style="display: inline-block;width: 70px;text-align: right; margin-right: 5px;">时间:</span>
        <el-date-picker v-model="search_time" type="datetimerange" range-separator="-" start-placeholder="开始日期"
          end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange"
          style="width: 200px;">
        </el-date-picker>



      </el-row>


      <el-row type="flex" justify="center" style="margin-bottom: 20px;">

        <span style="display: inline-block;width: 70px;text-align: right; margin-right: 5px;">密码:</span>
        <el-input v-model="submit_data.consumers_export_password" show-password style="width: 200px;"></el-input>



      </el-row>




      <div style="width: 500px; margin: 10px auto;" v-if="progress_show">

        <el-progress :percentage="progress_data"></el-progress>
        <i class="el-icon-loading"></i>
        正在导出...

      </div>

      <el-row type="flex" justify="center" v-else>

        <el-button type="primary" @click="toExport">导出乘客信息</el-button>


      </el-row>



    </div>




  </div>

</template>

<script>
  var _this;
  export default {

    data() {
      return {


        search_time: '',

        submit_data: {
          page: 1,
          fixed_array: '',
          consumers_export_password: ''
        },

        excelData: [],

        excelHead: [],

        progress_show: false,
        progress_data: 0

      };
    },
    created() {
      _this = this;
      console.log(this.$route.path);

    },

    methods: {
      timeChange(val) {
        if(val!=null){
          _this.submit_data.fixed_array = JSON.stringify(['between'].concat(val));

        }else{
          _this.submit_data.fixed_array = '';
        }

      },

      toExport() {

        _this.getExcelData();

      },

      getExcelData() {

        _this.$post(
          "/consumer/exportConsumerListsCsv",
          _this.submit_data
        ).then(res => {

          _this.progress_show = true;

          if (this.$route.path == '/userExport') {


            // 导出excel的空数组中添加数据
            for (let i = 0; i < res.data.list.length; i++) {

              _this.excelData.push({
                'name': res.data.list[i].name,
                'phone': res.data.list[i].phone,
                'balance': res.data.list[i].balance,
                'arrears': res.data.list[i].arrears,
                'all_order_num': res.data.list[i].all_order_num,
                'end_order_num': res.data.list[i].end_order_num,
                'last_order_time': res.data.list[i].last_order_time.YmdHis,
                'reg_from': res.data.list[i].reg_from.alias,
                'reg_time': res.data.list[i].reg_time.YmdHis,
              });


            }


            if (res.data.page * res.data.limit < res.data.count) {

              _this.submit_data.page = res.data.page + 1;

              _this.progress_data = Math.floor((res.data.page * res.data.limit / res.data.count) * 100);

              _this.getExcelData();

            } else {


              // console.log(_this.excelData);

              // 将数据导出execl
              _this.exportData();

              _this.submit_data.page = 1;

              // 清空数据
              _this.excelData = [];

              _this.progress_show = false;
              _this.progress_data = 0;


            }

          } else {

            _this.progress_show = false;
            _this.progress_data = 0;

          }



        }).catch((err) => {

        })

      },


      // 导出excel方法
      exportData() {
        const {
          export_json_to_excel
        } = require('@/vendor/Export2Excel');
        const tHeader = ['乘客姓名', '乘客电话', '余额', '欠款', '总下单数量', '已完成订单数量', '最后一次下单时间', '注册平台', '注册时间'];
        const filterVal = ['name', 'phone', 'balance', 'arrears', 'all_order_num', 'end_order_num', 'last_order_time',
          'reg_from', 'reg_time'
        ];
        const list = this.excelData;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, 'fileName');
      },

      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },



   
    }
  };
</script>

<style scoped>

</style>